// extracted by mini-css-extract-plugin
export default {"IngredientsColumn":"ingredients-column_IngredientsColumn__8WMRv"};